module.exports = MaterialUI.ListItemText;